import LandingNav from "./components/LandingNav";
import HeroSection from "./components/HeroSection";
import StatsSection from "./components/StatsSection";
import WorkflowSection from "./components/WorkflowSection";
import UserTabsSection from "./components/UserTabsSection";
import FeaturesSection from "./components/FeaturesSection";
import CasesSection from "./components/CasesSection";
import PricingSection from "./components/PricingSection";
import FooterSection from "./components/FooterSection";

export default function LandingPage() {
  return (
    <div className="bg-[#080808] min-h-screen">
      <LandingNav />
      <HeroSection />
      <StatsSection />
      <WorkflowSection />
      <UserTabsSection />
      <FeaturesSection />
      <CasesSection />
      <PricingSection />
      <FooterSection />
    </div>
  );
}
